import {
  TERMS_AND_CONDITIONS,
  TERMS_AND_CONDITIONS_TOPIC
} from "../actionTypes/index";

const initialState = {
  list: {},
  topic: {}
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case TERMS_AND_CONDITIONS:
      return {
        ...state,
        list: payload
      };

    case TERMS_AND_CONDITIONS_TOPIC:
      return {
        ...state,
        topic: payload
      };
    default:
      return state;
  }
};
